module.exports = __webpack_public_path__ + "static/media/dua-lipa-win.fd2fbbc7.jpg";